export const SKIN_TEMPS = {
  skin_temp1: "日中最高温度",
  skin_temp2: "日中最低温度",
  skin_temp3: "日中平均温度",
  skin_temp4: "睡眠時最高温度",
  skin_temp5: "睡眠時最低温度",
  skin_temp6: "睡眠時平均温度",
};
export const SKIN_TEMPS_KEYS = [
  "skin_temp1",
  "skin_temp2",
  "skin_temp3",
  "skin_temp4",
  "skin_temp5",
  "skin_temp6",
];
